import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PlanDto, PlanPriceDto } from '../../models/plan.model';
import { PaymentFlowSnapshot, PaymentFlowStateService } from '../../services/payment-flow-state.service';
import { getWompiPriceEligibility } from '../../utils/wompi-price-eligibility.util';

@Component({
  selector: 'app-plan-upgrade-cta',
  templateUrl: './plan-upgrade-cta.component.html',
  styleUrls: ['./plan-upgrade-cta.component.scss'],
  standalone: false
})
export class PlanUpgradeCtaComponent {
  @Input() accountId: number | null = null;
  @Input() plan: PlanDto | null = null;
  @Input() price: PlanPriceDto | null = null;
  @Input() disabled = false;

  @Output() paymentFinished = new EventEmitter<PaymentFlowSnapshot>();

  showConfirm = false;
  snapshot: PaymentFlowSnapshot = { phase: 'idle' };

  constructor(private readonly paymentFlow: PaymentFlowStateService) {}

  get wompiEnabled(): boolean {
    return !!environment.features?.wompiEnabled;
  }

  get eligibility() {
    return getWompiPriceEligibility(this.price);
  }

  get canPay(): boolean {
    return this.wompiEnabled
      && this.eligibility.eligible
      && !!this.accountId
      && !!this.plan
      && !!this.price
      && !this.isBusy
      && !this.disabled;
  }

  get isBusy(): boolean {
    return this.snapshot.phase === 'checking_pending'
      || this.snapshot.phase === 'creating_order'
      || this.snapshot.phase === 'widget_open'
      || this.snapshot.phase === 'pending_confirmation';
  }

  open(): void {
    if (!this.canPay) {
      return;
    }
    this.showConfirm = true;
  }

  confirm(): void {
    if (!this.canPay || !this.accountId || !this.plan || !this.price) {
      return;
    }
    const redirectUrl = `${window.location.origin}/usage`;
    this.paymentFlow.createOrderAndOpenWidget({
      accountId: this.accountId,
      planId: this.plan.id,
      planPriceId: this.price.id,
      currencyCode: this.price.currencyCode as 'COP',
      billingPeriod: this.price.billingPeriod === 'yearly' ? 'yearly' : 'monthly'
    }, redirectUrl).subscribe((snapshot) => {
      this.snapshot = snapshot;
      this.showConfirm = false;
      this.paymentFinished.emit(snapshot);
    });
  }
}
